function cardNumber(value) {
  if (value) {
    const numberGroups = value.toString().replace(/[^a-zA-Z0-9]/g, '').match(/.{1,4}/g);
    let result = '';

    numberGroups.forEach((group) => {
      result += `${group} `;
    });

    return result.trim();
  }

  return '';
}



export default cardNumber;
